import { render, staticRenderFns } from "./manipulacaoItensCapsula.vue?vue&type=template&id=9c7bf1fa&class=crud-item-grid"
import script from "./manipulacaoItensCapsula.ts?vue&type=script&lang=js&external"
export * from "./manipulacaoItensCapsula.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c7bf1fa')) {
      api.createRecord('9c7bf1fa', component.options)
    } else {
      api.reload('9c7bf1fa', component.options)
    }
    module.hot.accept("./manipulacaoItensCapsula.vue?vue&type=template&id=9c7bf1fa&class=crud-item-grid", function () {
      api.rerender('9c7bf1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacaoNew/manipulacaoItensCapsula/manipulacaoItensCapsula.vue"
export default component.exports